import { useEffect, useState } from 'react'

import { ButtonSubmit, Content, Title } from '../../GlobalStyle'
import api from '../../hooks/API'
import { Mask } from '../../hooks/Mask'
import { reverseFormatPercent } from '../../hooks/removeFormat'
import BoxShadow from '../components/BoxShadowDiv'
import { ButtonDiv, Grid, InputDiv, ItemInput, Label, Plataforms } from './style'

import { ProgressSpinner } from 'primereact/progressspinner'
import { useQuery, useQueryClient } from 'react-query'
import { useAddPlataforms } from '../../hooks/mutations'
import Header from '../components/Header'
import InputComponent from '../components/Input'

const Expenses = () => {
  const queryClient = useQueryClient()
  const user = queryClient.getQueryData('profile')
  const { isLoading, data: plataforms } = useQuery(['plataforms'], () => api.getPlataforms())

  const { mutate: updatePlataforms } = useAddPlataforms()

  const [plat1, setPlat1] = useState({ nome: '', despesas: Mask.percent(0) })
  const [plat2, setPlat2] = useState({ nome: '', despesas: Mask.percent(0) })

  const handleSubmit = () => {
    updatePlataforms({
      plataformas: [
        { id: plat1.id, nome: plat1.nome, despesas: reverseFormatPercent(plat1.despesas) },
        { id: plat2.id, nome: plat2.nome, despesas: reverseFormatPercent(plat2.despesas) },
      ],
    })
  }

  useEffect(() => {
    setPlat1({ nome: user?.nome })
    if (plataforms?.length > 1)
      setPlat1({
        id: plataforms[1]?.id,
        nome: user?.nome,
        despesas: Mask.percent(plataforms[1]?.despesas),
      })

    if (plataforms?.length > 2)
      setPlat2({
        ...plat2,
        id: plataforms[2]?.id,
        nome: plataforms[2]?.nome,
        despesas: Mask.percent(plataforms[2]?.despesas),
      })
  }, [plataforms])

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <ProgressSpinner size="6rem" />
      </div>
    )
  }

  return (
    <Content>
      <Title>Despesas das plataformas</Title>
      <BoxShadow>
        {<Header title={'Plataformas'} />}
        <InputDiv>
          <Plataforms>
            <Grid>
              <ItemInput grid={'auto 1fr'}>
                <Label>Nome da plataforma 1</Label>
                <InputComponent value={plat1.nome} disabled />
              </ItemInput>
              <ItemInput grid={'auto 1fr'}>
                <Label>Despesas</Label>
                <InputComponent
                  value={plat1.despesas}
                  onChange={(e) => setPlat1({ ...plat1, despesas: Mask.percent(e.target.value) })}
                />
              </ItemInput>
            </Grid>
            <Grid>
              <ItemInput grid={'auto 1fr'}>
                <Label>Nome da plataforma 2</Label>
                <InputComponent
                  value={plat2.nome}
                  onChange={(e) => setPlat2({ ...plat2, nome: e.target.value })}
                />
              </ItemInput>
              <ItemInput grid={'auto 1fr'}>
                <Label>Despesas</Label>
                <InputComponent
                  value={plat2.despesas}
                  onChange={(e) => setPlat2({ ...plat2, despesas: Mask.percent(e.target.value) })}
                />
              </ItemInput>
            </Grid>
          </Plataforms>

          <ButtonDiv>
            <ButtonSubmit margin={'15px 0px 0px 0px'} type="button" onClick={() => handleSubmit()}>
              Salvar
            </ButtonSubmit>
          </ButtonDiv>
        </InputDiv>
      </BoxShadow>
    </Content>
  )
}
export default Expenses
